module.exports = __webpack_public_path__ + "static/media/logo-main.73d6182e.png";